module.exports = __webpack_public_path__ + "static/media/Tvs.486076c3.jpg";